import { isValidArrayInnerType } from '@doss/common-all'
import { ActiveUser } from '~/components/settings/types'
import { FileArrayTableCell } from '~/components/table-cells/ArrayTableCells/FileArrayTableCell'
import { DataType } from '../../../common/generated/apollo-operations'
import { DetailedTableColumn, DossTableCell } from '../../tables/types'
import { EnumArrayTableCell } from './EnumArrayTableCell'
import { LookupArrayTableCell } from './LookupArrayTableCell'
import { UserArrayTableCell } from './UserArrayTableCell'

interface ArrayTableCellProps {
  tableColumn: DetailedTableColumn
  value: string[]
  cell: DossTableCell
  displayImage: boolean
  readOnly: boolean
  activeUsers: ActiveUser[]
}

/**
 * Renders a cell for a column of type ARRAY
 */
export function ArrayTableCell({
  tableColumn,
  value,
  cell,
  displayImage,
  readOnly,
  activeUsers,
}: ArrayTableCellProps) {
  const { innerType } = tableColumn
  if (!Array.isArray(value) || !isValidArrayInnerType(innerType)) {
    return null
  }
  switch (innerType) {
    case DataType.ENUM:
      return <EnumArrayTableCell enumSetOptions={tableColumn.enumSet?.options} value={value} />
    case DataType.FILE_URL:
      return (
        <FileArrayTableCell
          displayImage={displayImage}
          value={cell.documents.map((document) => document.id)}
        />
      )
    case DataType.USER: {
      const users = cell.users.map((user) => {
        const activeUser = activeUsers.find((activeUser) => activeUser.id === user.id)
        return activeUser ?? user
      })
      return <UserArrayTableCell users={users} />
    }
    case DataType.LOOKUP:
      return (
        <LookupArrayTableCell
          cell={cell}
          lookupColumn={tableColumn.lookupColumn}
          readOnly={readOnly}
        />
      )
  }
}
